import FieldBase from './FieldBase'

export default class extends FieldBase {
  constructor({
    type = 'text',
    clearable = false,
    disabled = false,
    autosize = undefined,
    placeholder = undefined,
    ...args
  }) {
    super(args)
    const child = this.getComponentWithVModel('el-input')
    child.attrs.type = type
    child.attrs.clearable = clearable
    child.attrs.disabled = disabled
    child.attrs.autosize = autosize
    child.attrs.placeholder = placeholder
    this.children = [child]
  }
}
